export type Freshness = 'fresh' | 'stale' | 'no_data';

// Until channels carry an observed cadence, "stale" is a single documented
// threshold: no signal for 7 days. 'demo' is deliberately not derived here -
// it must be an explicit server flag, never inferred.
export const STALE_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export function freshnessOf(lastUpdatedAt: number, now: number = Date.now()): Freshness {
  if (!lastUpdatedAt) return 'no_data';
  return now - lastUpdatedAt > STALE_AFTER_MS ? 'stale' : 'fresh';
}

export const FRESHNESS_LABEL: Record<Freshness, string> = {
  fresh: 'Up to date',
  stale: 'Stale',
  no_data: 'No data',
};
